export const fht=(fontSize, referenceWidth = 1920)=> {
  const parsedSize = parseFloat(fontSize);
  return {
    default: `${parsedSize}px`,
    responsive: `calc(${parsedSize}px * (100vw / ${referenceWidth}))`,
    clamp: `clamp(${parsedSize * 0.8}px, ${parsedSize}px, ${parsedSize * 1.2}px)`,
    breakpoint: (maxWidth) => `calc(${parsedSize}px * (${maxWidth} / ${referenceWidth}))`
  };
}

export const theme = {
  colors: {
    primary: '#7033FF', // Purple
    secondary: '#4513AA', // Dark Purple
    background: '#F7F7FA', // Light Background
    white: '#FFFFFF',
    black: '#000000',
    gray: {
      100: '#F6F4FA', // Lightest Gray
      200: '#EDEDED', // Light Gray
      300: '#D9D9D9', // Medium Light Gray
      400: '#999999', // Medium Gray
      500: '#757575', // Medium Dark Gray
      600: '#6A6A6A', // Dark Gray
      700: '#333333', // Very Dark Gray
      800: '#282828', // Almost Black
    },
    overlay: 'rgba(25, 15, 73, 0.2)',
    transparentWhite: 'rgba(255, 255, 255, 0.7)',
    transparentBlack: 'rgba(0, 0, 0, 0.7)',
    gradients: {
      background: 'linear-gradient(180deg, #08090D 0%, rgba(8, 9, 13, 0.9) 100%)',
      purpleGlow: 'radial-gradient(circle, #8C57FF 0%, rgba(121, 87, 255, 0) 100%)',
      blueGlow: 'radial-gradient(circle, #3576D1 0%, rgba(53, 118, 209, 0) 100%)',
      videoBackground: 'linear-gradient(180deg, rgba(69, 19, 170, 0.2) 0%, rgba(69, 19, 170, 0) 100%)',
      contentBackground: 'linear-gradient(180deg, rgba(8, 9, 13, 0.8) 0%, rgba(8, 9, 13, 0.6) 100%)',
    },
    askButton: '#F2EFF9',
    askButtonText: '#4513AA',
    respondButton: '#190F49',
    searchBarBg: 'rgba(25, 15, 73, 0.06)',
    voiceSearchBg: 'rgba(57, 68, 225, 0.1)',
    voiceSearchIcon: '#434EEB',
    activeNavItem: '#7033FF',
    inactiveNavItem: '#999999',
    qpointActive: '#4513AA',
    qpointInactive: 'rgba(25, 15, 73, 0.2)',
    qpointText: '#FFFFFF',
    qpointBorder: '#4513AA',
    qpointInactiveBorder: 'rgba(25, 15, 73, 0.2)',
    videoCircleBorder: 'rgba(255, 255, 255, 0.2)',
    progressBarBackground: 'rgba(25, 15, 73, 0.2)',
    navButtonBackground: 'rgba(28, 28, 28, 0.2)',
  },
  shadows: {
    small: '0px 4px 50px 0px rgba(0, 0, 0, 0.1), inset 0px 4px 64px 0px rgba(255, 255, 255, 0.24)',
    medium: '0px 6px 60px 0px rgba(0, 0, 0, 0.08), inset 0px 4px 64px 0px rgba(255, 255, 255, 0.12)',
    large: '0px 6px 70px 0px rgba(0, 0, 0, 0.06), inset 0px 4px 60px 0px rgba(255, 255, 255, 0.4)',
    videoShadow: '0px 30px 180px -20px rgba(0, 0, 0, 0.1)',
    responseShadow: '0px 6px 70px 0px rgba(0, 0, 0, 0.06), inset 0px 4px 60px 0px rgba(255, 255, 255, 0.4)',
    avatarShadow: '0px 30px 100px -20px rgba(0, 0, 0, 0.2)',
    buttonShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
    videoCircleShadow: '0px 30px 90px rgba(0, 0, 0, 0.25)',
  },
  borderRadius: {
    small: '8px',
    medium: '16px',
    large: '20px',
    xl: '40px',
    circle: '50%',
    pill: '100px',
  },
  fonts: {
    primary: 'Figtree',
    secondary: 'Sen',
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  fontSizes: {
    xs: '10px',
    sm: '12px',
    md: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
    xxli: '28px',
    xxxl: '32px',
    xxxxl: '34px',
    xxxxxl: '36px',
    extra: '48px'
  },
  blur: {
    light: 'blur(2px)',
    medium: 'blur(10px)',
    heavy: 'blur(180px)',
  },
  zIndex: {
    base: 1,
    menu: 10,
    modal: 100,
    tooltip: 1000,
  },
  breakpoints: {
    mini: 360,
    mobile: 480,
    mobileBig:520,
    tablet: 768,
    tabletAir: 820,
    maxTablet: 1023,
    desktop: 1024,
    maxDesktop: 1440,
    maxDesktopPlus: 1920,
  },
};

export type Theme = typeof theme; 